export const environment = {
  production: true,
  ssoUrl: 'https://login.gov.pl/login/SingleSignOnService'
};
